module.exports = __webpack_public_path__ + "static/RapidContracts-logo-69b321058c4813e314a481c38c87b71a.svg";